import { useState, useEffect } from 'react';
import { Customer } from '../../../../api/mobiApi/domain/domain.types';


export const useCustomerManagement = () => {
  const [allCustomers, setAllCustomers] = useState<Customer[]>([]);
  const [selectedCustomers, setSelectedCustomers] = useState<Customer[]>([]);

  useEffect(() => {
    loadCustomers();
  }, []);

  const loadCustomers = async () => {
    try {
      const stored = localStorage.getItem('mobiroute_customers');
      if (stored) {
        const customers = JSON.parse(stored);
        const validCustomers = customers.filter((c: any) =>
          Number.isFinite(c?.lat) &&
          Number.isFinite(c?.lon) &&
          c.lat !== 0 &&
          c.lon !== 0
        );
        setAllCustomers(validCustomers);
        console.log(`✅ ${validCustomers.length} müşteri yüklendi`);
      }
    } catch (error) {
      console.error('❌ Müşteri yükleme hatası:', error);
    }
  };

  const toggleCustomer = (customer: Customer) => {
    const isSelected = selectedCustomers.some(c => c.id === customer.id);
    setSelectedCustomers(prev =>
      isSelected ? prev.filter(c => c.id !== customer.id) : [...prev, customer]
    );
  };

  const selectAllCustomers = () => {
    setSelectedCustomers([...allCustomers]);
  };

  const clearSelectedCustomers = () => {
    setSelectedCustomers([]);
  };

  const getTotalDemand = () => {
    return selectedCustomers.reduce((sum, c) => sum + (c.demand || 0), 0);
  };

  return {
    allCustomers,
    selectedCustomers,
    setSelectedCustomers,
    toggleCustomer,
    selectAllCustomers,
    clearSelectedCustomers,
    getTotalDemand
  };
};
